import { getTypographyStyles, SYS_SPACE_FIXED_150, SYS_SPACE_FIXED_300, getMargins, SEM_TYPOGRAPHY_FORMS_LABEL_SMALL } from '@oneaudi/unified-web-alpha-common';
import styled, { css } from 'styled-components';
import { FormMessage } from '../form-message/index.js';
import {} from './index.js';
export const StyledFieldset = styled.fieldset `
  margin: ${(props) => getMargins(props.margin) || 0};
  border: none;
  padding: 0;

  ${(props) => !props.hasHintOrLegend &&
    css `
      display: flex;
      flex-direction: ${props.variant === 'horizontal' ? 'row' : 'column'};
      flex-wrap: wrap;
      gap: ${SYS_SPACE_FIXED_300};
    `}
`;
export const StyledLegend = styled.legend `
  padding: 0;
  color: ${(props) => props.disabled
    ? props.theme.sem.color.forms.foreground.text.disabled
    : props.invalid
        ? props.theme.sem.color.forms.foreground.text.error
        : props.theme.sem.color.forms.foreground.text.default};
  ${getTypographyStyles(SEM_TYPOGRAPHY_FORMS_LABEL_SMALL)}
  margin-bottom: ${SYS_SPACE_FIXED_150};
`;
export const StyledInner = styled.div `
  display: flex;
  flex-direction: ${(props) => props.variant === 'horizontal' ? 'row' : 'column'};
  flex-wrap: wrap;
  gap: ${SYS_SPACE_FIXED_300};
`;
export const StyledFormMessage = styled(FormMessage) `
  margin-top: ${SYS_SPACE_FIXED_150};
`;
//# sourceMappingURL=index.styles.js.map